export { Table } from './table.component';
